import { sleep } from './time.utils';

export interface PollParams<T> {
  fn: () => Promise<T>;
  finishCondition: (result: T) => boolean;
  onUpdate?: (result: T) => void;
  onFinish?: (result: T) => void;
  timeoutMs?: number;
  onTimeout?: () => void;
  signal?: AbortSignal;
  ms?: number;
}

export const poll = async <T>({
  fn,
  finishCondition,
  onUpdate,
  onFinish,
  timeoutMs,
  onTimeout,
  signal,
  ms = 500,
}: PollParams<T>) => {
  const timeoutController = new AbortController();
  const timeoutSignal = timeoutController.signal;

  let timeout;
  if (timeoutMs)
    timeout = setTimeout(() => {
      timeoutController.abort();
    }, timeoutMs);

  try {
    let result = await fn();

    while (!finishCondition(result)) {
      if (timeoutSignal.aborted || signal?.aborted) break;
      onUpdate?.(result);
      await sleep(ms);
      if (timeoutSignal.aborted || signal?.aborted) break;
      result = await fn();
    }

    if (timeoutSignal.aborted) {
      onTimeout?.();
      return;
    }

    if (signal?.aborted) return;

    onFinish?.(result);
  } finally {
    clearTimeout(timeout);
  }
};
